import { render, staticRenderFns } from "./AutoReloadData.vue?vue&type=template&id=722419e1&scoped=true"
import script from "./AutoReloadData.vue?vue&type=script&lang=js"
export * from "./AutoReloadData.vue?vue&type=script&lang=js"
import style0 from "./AutoReloadData.vue?vue&type=style&index=0&id=722419e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722419e1",
  null
  
)

export default component.exports